import type { SVGProps } from 'react';
const SvgIconRightThin = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path
      fill="currentColor"
      fillOpacity={0.45}
      d="M12.53 7.55 4.48 1.263a.142.142 0 0 0-.23.112v1.38c0 .088.041.172.109.226L10.788 8l-6.43 5.02a.28.28 0 0 0-.108.224v1.38c0 .12.138.186.23.113l8.05-6.288a.57.57 0 0 0 0-.9"
    />
  </svg>
);
export default SvgIconRightThin;
